import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getUserUID } from '../auth/auth.selector';
import * as WhitelistActions from './whitelist.action';
import WhitelistAPI from './whitelist.api';
import { WhitelistActionTypes } from './whitelist.model';

export function* handleFetchWhitelist(action) {
    try {
        const user = yield select(getUserUID);
        const response = yield call(WhitelistAPI.GetWhitelists, user);
        yield put(WhitelistActions.fetchWhitelistSuccess(response));
    } catch (e) {
        yield put(WhitelistActions.fetchWhitelistFailure(e));
    }
}
export function* WhitelistSaga() {
    yield takeEvery(WhitelistActionTypes.FETCH_WHITELIST_REQUEST, handleFetchWhitelist);
}
